import { SecurityGroup } from '../../../models';
import { SecurityGroup as OctopusSecurityGroup } from '../models/security-group';
import { ConfigurationMapper } from './configuration';

export class SecurityGroupMapper extends ConfigurationMapper<
  OctopusSecurityGroup[],
  SecurityGroup[]
> {
  from(source: OctopusSecurityGroup[]): SecurityGroup[] {
    return source.map((item) => {
      return {
        ...this.mapKeyAndDisplay(item),
        members:
          item.MemberKeys?.map((member) => this.mapKeyAndDisplay(member)) || [],
      };
    });
  }
}
